import React from 'react';
import styles from './EmptyState.module.css';
import Ico from './Ico';

export default function EmptyState({ icon, title, hint, action }) {
  return (
    <div className={styles.wrap}>
      {icon && (
        <div className={styles.iconWrap}>
          <Ico d={icon} size={18} />
        </div>
      )}
      {title && <div className={styles.title}>{title}</div>}
      {hint && <div className={styles.hint}>{hint}</div>}
      {action && <div className={styles.actionRow}>{action}</div>}
    </div>
  );
}
